<template>
    <div class="wb-sidebar-categories-scroll-btn-anchor"
         :class="{'bottom': direction === 'down'}">
        <div class="wb-sidebar-categories-scroll-btn" :style="{'width': width}">
            <SVGArrowDown v-if="direction === 'down'"/>
            <SVGArrowUp v-else/>
        </div>
    </div>
</template>

<script>
import SVGArrowDown from '@/UI/Components/SVG/SVGArrowDown.vue';
import SVGArrowUp from '@/UI/Components/SVG/SVGArrowUp.vue';

export default {
    name: 'SidebarCategoriesScroll',
    components: {
        SVGArrowUp,
        SVGArrowDown,
    },
    props: [
        'direction',
        'width',
    ],
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/animations.scss";
@import "CSS/common.scss";

.wb-sidebar-categories-scroll-btn-anchor {
    position: absolute;
    height: 0;
    z-index: 11;
}

.wb-sidebar-categories-scroll-btn {
    position: relative;
    height: 49px;
    background-color: $darkBlue80;
    color: $white;
    @include button-smooth;
    @include wb-c-flex-center;
}

.wb-sidebar-categories-scroll-btn:hover {
    background-color: $green1;
}

.bottom {
    bottom: 49px
}
</style>
